<div class="mb-3 clearfix">
  <div class="pull-let wd-md">
    <input [(ngModel)]="filterColumnText" placeholder="Filter all columns" class="form-control"
           (keyup)='updateFunctionFilter($event)'/>
  </div>
</div>
<div class="card card-default">
  <div class="card-body">
    <div class="table-responsive">
      <table #functionTable class="table table-striped table-sm table-bordered">
        <thead>
        <tr>
          <th scope="col">
            <div class="checkbox c-checkbox">
              <label>
                <input type="checkbox" [(ngModel)]="isCheckAll" (change)="selectAll()"/>
                <span class="fa fa-check"></span>
              </label>
            </div>
          </th>
          <th filterable="categoryName" scope="col">Category</th>
          <th filterable="name" scope="col">Name</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let row of rows">
          <td scope="row">
            <div class="checkbox c-checkbox">
              <label>
                <input type="checkbox" [(ngModel)]="row.isChecked"/>
                <span class="fa fa-check"></span>
              </label>
            </div>
          </td>
          <td>{{row.categoryName}}</td>
          <td>{{row.functionName}}</td>
        </tr>
        </tbody>
      </table>
      <br/>
      <div class="text-right">
        <pagination *ngIf="paginationEnabled" class="pagination-sm" [(ngModel)]="page" [totalItems]="length"
                    [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false"
                    (pageChanged)="onChangeTable($event)" (numPages)="numPages = $event">
        </pagination>
      </div>
    </div>
  </div>
  <div class="card-footer">
    <div class="row">
      <div class="col-8">
        <button class="btn btn-labeled btn-info mb-2 btn-sm" type="button" [disabled]="!showAddSelectedButton()"
                (click)="addSelectedFunctions()">
          <span class="btn-label">
            <i class="fa fa-plus"></i>
          </span>Add Selected
        </button>
        &nbsp;&nbsp;
        <span class="text-danger" *ngIf="getSelectedCountText() != null">
          {{ getSelectedCountText() }}
          <a class="text-danger" href="#" (click)="unSelectAll($event)"> <i class="fa fa-close"></i></a>
        </span>
      </div>
      <div class="col-4 float-right" style="text-align: right;">
        <button class="btn btn-labeled btn-secondary mb-2 btn-sm" type="button"
                (click)="closeModalClicked.emit()">
          <span class="btn-label">
            <i class="fa fa-close"></i>
          </span>
          Close
        </button>
      </div>
    </div>
  </div>
</div>
